document.addEventListener('DOMContentLoaded', function() {
  
  function updatePriceDisplay(variant) {
    if (!variant) return;
    
    const formatPrice = (price) => {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(price / 100) + ' GBP';
    };
    
    const regularPriceItems = document.querySelectorAll('.price-item--regular');
    regularPriceItems.forEach(item => {
      item.textContent = formatPrice(variant.price);
    });
    
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const salePriceItems = document.querySelectorAll('.price-item--sale');
      salePriceItems.forEach(item => {
        item.textContent = formatPrice(variant.compare_at_price);
      });
    }
  }
  
  if (customElements.get('product-info')) {
    const ProductInfoPrototype = customElements.get('product-info').prototype;

    ProductInfoPrototype.updateMedia = function(html, variantFeaturedMediaId) {
      if (!variantFeaturedMediaId) return;

      const mediaGallery = this.querySelector('media-gallery');
      if (!mediaGallery) return;

      const mainGallerySource = mediaGallery.querySelector('.swiper-wrapper');
      const thumbGallerySource = mediaGallery.querySelector('.product-gallery-thumbs .swiper-wrapper');
      
      const updatedMediaGallery = html.querySelector('media-gallery');
      if (!updatedMediaGallery) return;
      
      const mainGalleryDestination = updatedMediaGallery.querySelector('.swiper-wrapper');
      const thumbGalleryDestination = updatedMediaGallery.querySelector('.product-gallery-thumbs .swiper-wrapper');

      if (mainGallerySource && mainGalleryDestination) {
        this.updateSwiperGallery(mainGallerySource, mainGalleryDestination);
      }

      if (thumbGallerySource && thumbGalleryDestination) {
        this.updateSwiperGallery(thumbGallerySource, thumbGalleryDestination);
      }

      mediaGallery.setActiveMedia?.(`${this.dataset.section}-${variantFeaturedMediaId}`, true);
      mediaGallery.updateGallery?.();

      const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
      const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
      if (modalContent && newModalContent) {
        modalContent.innerHTML = newModalContent.innerHTML;
      }
    };

    ProductInfoPrototype.updateSwiperGallery = function(sourceWrapper, destinationWrapper) {
      const refreshSourceData = () => {
        const sourceItems = Array.from(sourceWrapper.querySelectorAll('.swiper-slide[data-media-id]'));
        const sourceSet = new Set(sourceItems.map((item) => item.dataset.mediaId));
        const sourceMap = new Map(
          sourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
        );
        return [sourceItems, sourceSet, sourceMap];
      };

      let [sourceItems, sourceSet, sourceMap] = refreshSourceData();
      const destinationItems = Array.from(destinationWrapper.querySelectorAll('.swiper-slide[data-media-id]'));
      const destinationSet = new Set(destinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      for (let i = destinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(destinationItems[i].dataset.mediaId)) {
          sourceWrapper.prepend(destinationItems[i]);
          shouldRefresh = true;
        }
      }

      for (let i = 0; i < sourceItems.length; i++) {
        if (!destinationSet.has(sourceItems[i].dataset.mediaId)) {
          sourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      if (shouldRefresh) [sourceItems, sourceSet, sourceMap] = refreshSourceData();

      destinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          sourceWrapper.insertBefore(
            sourceData.item,
            sourceWrapper.querySelector(`.swiper-slide:nth-of-type(${destinationIndex + 1})`)
          );

          [sourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    };
  }
  
  if (typeof subscribe !== 'undefined' && window.PUB_SUB_EVENTS) {
    subscribe(window.PUB_SUB_EVENTS.variantChange, function(event) {
      updatePriceDisplay(event.data.variant);
    });
  }
  
  let currentUrl = window.location.href;
  const observer = new MutationObserver(function() {
    if (window.location.href !== currentUrl) {
      currentUrl = window.location.href;
      
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      
      if (variantId) {
        fetch(`/products/${window.location.pathname.split('/').pop()}.js`)
          .then(response => response.json())
          .then(product => {
            const variant = product.variants.find(v => v.id == variantId);
            if (variant) {
              updatePriceDisplay(variant);
            }
          })
          .catch(error => console.error('Error fetching product:', error));
      }
    }
  });
  
  observer.observe(document, { subtree: true, childList: true });
  
  window.addEventListener('popstate', function() {
    setTimeout(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      
      if (variantId) {
        fetch(`/products/${window.location.pathname.split('/').pop()}.js`)
          .then(response => response.json())
          .then(product => {
            const variant = product.variants.find(v => v.id == variantId);
            if (variant) {
              updatePriceDisplay(variant);
            }
          });
      }
    }, 100);
  });
  
  const variantInputs = document.querySelectorAll('input[name^="options"], select[name^="options"]');
  variantInputs.forEach(input => {
    input.addEventListener('change', function() {
      setTimeout(() => {
        const variantIdInput = document.querySelector('input[name="id"]');
        if (variantIdInput && variantIdInput.value) {
          const variantId = variantIdInput.value;
          const productHandle = window.location.pathname.split('/').pop();
          
          fetch(`/products/${productHandle}.js`)
            .then(response => response.json())
            .then(product => {
              const variant = product.variants.find(v => v.id == variantId);
              if (variant) {
                updatePriceDisplay(variant);
              }
            })
            .catch(error => console.error('Error fetching variant:', error));
        }
      }, 500);
    });
  });
  
});